import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    modelValue: {},
    type: {
      default: 'text'
    }
  },
  emits: ['update:modelValue']
});